
import React from 'react';

const HighLights = ({ data, className = '' }) =>
  (<section className={className} >
    <div className='container c-mw'>
      <div className='row'>
        <div className='col-12'>
          <ul className='c-list text-center'>
            {data.map(({ title, description, sublist }, i) =>
              (<li className='mb-4 mb-md-5' key={i}>
                <h3 className=''>
                  {title}
                </h3>
                <h4 className='c-light'>
                  {description}
                </h4>
              </li>),
            )}
          </ul>
        </div>
      </div>
    </div>
  </section>);

export default HighLights;



// WEBPACK FOOTER //
// ./src/components/highlights/index.js